import * as React from 'react';

import type { PrivateCourseFieldsFragment } from 'bundles/enterprise-collections/queries/__generated__/PrivateCourses';

type CustomCoursesContextType = {
  privateCourses: PrivateCourseFieldsFragment[];
  totalCollections: number;
};

const CustomCoursesContext = React.createContext<CustomCoursesContextType>({
  privateCourses: [],
  totalCollections: 0,
});

export const useCustomCourses = () => React.useContext(CustomCoursesContext);

export default CustomCoursesContext;
